<template>
    <div class="EntryComparison">
        <table class="EntryComparison-table">
            <thead>
                <tr>
                    <th>Orientační přehled cen realizace zahrady dle vybraného cenového programu</th>
                    <th v-for="(bundle, key) in bundles" :key="key" @click="selectEntry(key)"
                        class="EntryComparison-bundle" :class="{ 'is-selected': bundle.selected }">
                        <span>{{ bundle.title }}</span>
                        <small>{{ bundle.tagline.replace('Zahrada', '') }}</small>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, itemKey) in items" :key="item.title">
                    <td>{{ item.title }}</td>
                    <td v-for="(bundle, key) in bundles" :key="key" @click="selectEntry(key)"
                        class="EntryComparison-bundle" :class="{ 'is-selected': bundle.selected }">
                        <svg v-if="bundle.items.map(bundle => bundle.key).includes(itemKey)" xmlns="http://www.w3.org/2000/svg" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="27" height="24" fill="currentColor"><g><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" vector-effect="non-scaling-stroke"/></g></svg>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'EntryComparison',
    props: {
        items: Object,
        bundles: Object
    },
    setup(props) {
        const selectEntry = (id) => {
            Object.entries(props.bundles).forEach(([key, bundle]) => {
                bundle.selected = key === id;
            });
        }

        return {
            selectEntry
        }
    }
}
</script>

<style lang="scss" scoped>
.EntryComparison {
    margin-top: 2rem;

    @media(max-width: 980px) {
        display: none;
    }

    &-table {
        width: 100%;
        border: 2px solid #b4c373;
        border-collapse: collapse;

        tr > *:first-child {
            width: 32%;
            text-align: right
        }

        tbody {
            tr:first-child > * {
                padding-top: 12px;
            }

            tr:last-child > * {
                padding-bottom: 12px;
            }
        }

        th {
            border-bottom: 2px solid #b4c373;
            background: #f1f2ec;
            padding: 20px;

            span {
                display: block;
                color: #c33883;
                font-size: 1rem;
                line-height: 1.2;
                margin-bottom: 4px;
            }

            small {
                display: inline-block;
                font-size: 11px;
            }
        }

        td {
            padding: 4px 20px;
            border-bottom: 1px solid #eee;

            &:not(.is-selected):nth-of-type(even) {
                background: #f9f9f9;
            }
        }
    }

    &-bundle {
        text-align: center;
        cursor: pointer;
        width: 17%;

        &.is-selected {
            color: #fff;
            background: #b4c373;
            pointer-events: none;

            * {
                color: inherit !important;
            }
        }
    }
}
</style>